<template>
    <div class="single-answer">
        <div class="q-privew" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="q-number" v-if="currentQuestion.questionNo">Q {{currentQuestion.questionNo}}</div>
            <div class="q-number-Suggestions" v-if="currentQuestion.suggestions">Suggestions {{currentQuestion.suggestions}} </div>
            <div  @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" class="q-type"  :class="{'question-font':!questionFont(currentQuestion)}" v-html="currentQuestion.question_text"></div>
        </div>
        <div class="col-ans-row" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="col-i">
                <div class="col-title-center">Column I</div>
                <div
                    class="q-privew"
                    v-for="option in currentQuestion.options_abc"
                    :key="option.id"
                >
                    <div class="q-number">{{option.index}}</div>
                    <div class="q-type"  :class="{'option-font':!optionFont(option)}" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="option.option_text"></div>
                </div>
            </div>
            <div class="col-i">
                <div class="col-title-center">Column II</div>
                <div
                    class="q-privew"
                    v-for="option in currentQuestion.options_pqr"
                    :key="option.id"
                >
                    <div class="q-number">{{option.index}}</div>
                    <div class="q-type"   :class="{'option-font':!optionFont(option)}" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="option.option_text"></div>
                </div>
            </div>
        </div>

        <div v-if="showAnswerField" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="question-title py-3">Options</div>
            <div class="question-part">
                <div
                    v-for="(opt,opIndex) in currentQuestion.options"
                    :key="opIndex"
                    class="que-row"
                    :class="{'selected-option' : isQPchecked(opt, currentQuestion.correctAnswer) }"
					
                >
                    <div class="que-col-1">
                        <span class="opction-text">{{opt.index}}</span>
                        <div class="private-radio">
                            <input
                                type="radio"
                                @click="onRadioChange(opt)"
                                :disabled="currentQuestion.disabled"
                                :checked="isChecked(opt)"
                                color="red"
                                :id="opt.id"
                            />
                            <i
                                v-if="isChecked(opt)"
                                aria-hidden="true"
                                class="v-icon notranslate mdi mdi-radiobox-marked theme--light"
                                :class="currentQuestion.yourAnswer ? currentQuestion.correctAnswer === currentQuestion.yourAnswer ? 'green--text' : ' red--text' : currentQuestion.isPreview ?'green--text' : opt.correct_answer && 'blue--text'"
                                
                            ></i>
                            <i
                                v-else
                                aria-hidden="true"
                                class="v-icon notranslate mdi mdi-radiobox-blank theme--light"
                            ></i>
                        </div>
                    </div>
                    <div class="que-col-2">
                        <label :for="opt.id">  
                            <div @copy.prevent @contextmenu="rightClickDisable($event)"   :class="{'option-font':!optionFont(opt)}"  @mouseup="rightClickDisable($event)" v-html="opt.option_text"></div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="test-solution">
            <div v-if="isPastTest">
                <!-- ansStatus: {{currentQuestion.ansStatus}} -->
                <div>
                    <v-row>
                        <v-col cols="5"><label class="ans-text-3may">Your Answer: </label>{{currentQuestion.yourAnswer}}
                            <span v-if="currentQuestion.isBonus">
                                ({{ BONUS_MESSAGE }})
                            </span>
                        </v-col>
                        <v-col cols="6"><label class="ans-text-3may">Correct Answer: </label>{{currentQuestion.correctAnswer}}</v-col>
                        
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="2">Hint:</v-col>
                        <v-col cols="10">
                            <div v-html="currentQuestion.hint"></div>
                        </v-col>
                    </v-row>-->
                    <v-row
                        v-if="currentQuestion.solutionVideos && currentQuestion.solutionVideos.length"
                    >
                        <v-col cols="12">Video Solution:</v-col>
                        <v-col
                            cols="10"
                            v-for="video in currentQuestion.solutionVideos"
                            :key="video.id"
                        >
                            <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
                                <video height="100" width="150" controls>
                                    <source :src="video.video_url" />
                                </video>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="no-wrap ans-text-3may" cols="3" sm="1">Solution:</v-col>
                        <v-col cols="9" sm="11">
                            <div v-html="currentQuestion.solution"></div>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div v-if="(currentQuestion.solution&&currentQuestion.isPreview && currentQuestion.institute_id === null) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
			<div v-else-if="(currentQuestion.solution&&currentQuestion.isPreview) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div  @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "SingleAnsQue",
    props: ["currentQuestion", "showAnswerField","openMandatoryQuePopup", "practiceSessionView"],
    data() {
        return {};
    },
    mounted() {
        this.renderMath();
    },
    computed: {
        ...mapGetters("testStore", ["isPastTest"]),
    },
    methods: {
        ...mapActions({
            setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
        }),
        onRadioChange(opt) {
            if(this.currentQuestion.isAnswerDisabled === true){
                if(this.practiceSessionView!==true){
                    this.openMandatoryQuePopup();
                }
            }else{
                this.setDisableSecondaryAction(true);
                this.currentQuestion.isAnswered = true;
                this.currentQuestion.options = this.currentQuestion.options.map(
                    (x) => {
                        if (opt.index === x.index) {
                            x.correct_answer = true;
                        } else {
                            x.correct_answer = false;
                        }
                        return x;
                    }
                );
            }
        },
        rightClickDisable(e) {
            e.preventDefault();   
        },
        isQPchecked(opt,correct_answer) {
                if(this.currentQuestion.isPreview && !this.currentQuestion.isShowSolution) {
                    return this.isChecked(opt); 
                }
                else {
                    return this.isCorrect(opt, correct_answer);
            }
        },
        
    },
    watch: {
        "currentQuestion.id": function (val) {
            this.renderMath();
            this.renderMath();
        },
    },
};
</script>